const apiModules = require.context('./modules', true, /\.js$/)
const modules = apiModules.keys().reduce((pre, cur) => {
  return Object.assign(pre, apiModules(cur))
}, {})

module.exports = modules
